import { render } from "./SnapshotSource.vue?vue&type=template&id=37d4b0e2"
import script from "./SnapshotSource.vue?vue&type=script&lang=js"
export * from "./SnapshotSource.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__